export const documentsReducer = (state = { loading: false, resultdocument: null, documents: [], document: null, total: 0 }, action) => {
    switch (action.type) {
        case 'DOCUMENT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                documents: action.payload.documents,
                total: action.payload.total
            }
        case 'DOCUMENT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                document: action.payload
            }
        case 'DOCUMENT_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdocument: action.payload.message,
                document: action.payload.document,
                documents: [...state.documents, action.payload.document]
            }
        case 'DOCUMENT_EDIT_SUCCESS':
            if (action.payload.document) {
                return {
                    ...state,
                    loading: false,
                    resultdocument: action.payload.message,
                    document: action.payload.document,
                    documents: state.documents.map(doc => doc._id === action.payload.document._id ? action.payload.document : doc)
                }
            } else {
                return {
                    ...state,
                    loading: false,
                    resultdocument: action.payload
                }
            }
        case 'DOCUMENT_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdocument: action.payload.message,
                documents: state.documents.filter(doc => doc._id !== action.payload.document._id)
            }
        case 'DOCUMENT_RESET_RESULT':
            return {
                ...state,
                resultdocument: null
            }
        case 'DOCUMENT_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'DOCUMENT_NOT_LOADING':
        case 'DOCUMENT_ERROR':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}